import * as qs from 'qs';
import {API} from './API';

export class MaterialService {
  async getTableMaterials(params, additional = {}) {
    const [query, page, length] = API.getTableParams(params, additional);
    return this.getMaterials(query, page, length);
  }

  async getMaterials(query, page, length) {
    return (await API.getConnection())
      .get('materials', {
        params: {...query, ...{page, length}},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return API.handleError(error);
      });
  }

  async getMaterial(id, archive = false) {
    return (await API.getConnection())
      .get(`materials/${id}`, {
        params: archive ? {filter: {archive: 'only'}} : {},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        return API.handleError(error);
      });
  }

  async saveMaterial(data) {
    let method = 'post';
    let url = 'materials';
    if (data.id) {
      method = 'put';
      url = `${url}/${data.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async deleteMaterial(material) {
    return (await API.getConnection())
      .delete(`materials/${material.id}`)
      .then(() => null)
      .catch(error => API.handleError(error));
  }

  async restoreMaterial(material) {
    return (await API.getConnection())
      .put(`materials/${material.id}/restore`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
